import * as React from "react";
const SvgEventBusy = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m9.31 17 2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17ZM21 3h-3V1h-2v2H8V1H6v2H3.01L3 21h18V3Zm-2 16H5V8h14v11Z",
  fill: "currentColor"
}));
export default SvgEventBusy;